<template>
    <div class="third-party-report" v-if="report">
        <div class="module">
          <div class="module-title">图片</div>
          <ul class="pic-list">
            <li v-for="item in report.FileList" :key="item.Id">
              <!-- <img v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName" class="pic">
              <img v-else :src="item.IconUrl" alt="" class="pic"> -->
              <a v-if="item.FileType==2" href="javascript:void(0)" class="link" >
                <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt />
              </a>
              <a v-if="item.FileType==1" :href="item.FileUrl" class="link" >
                <img class="pic" :src="item.IconUrl" alt />
              </a>
            </li>
          </ul>
        </div>
        <div class="module">
          <div class="module-title">特殊说明</div>
          <div class="desc">{{report.Remark}}</div>
        </div>
    </div>
</template>
<script>
import {GetThirdReport} from '@/scripts/api.js'
export default {
    data(){
        return{
            jobNo:'',
            report:null,
        }
    },
    watch: {
        report(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
    },
    created() {
        this.jobNo=this.$route.query.jobNo;
        this.init();
    },
    methods: {
        init(){
          GetThirdReport({platform:'pcweb',jobNo:this.jobNo}).then(r=>{
            if(r.Result==1){
              this.report=r.Data.ThirdReport;
            }else{
              this.$toast(r.Message);
            }
          })
        }
    },
}
</script>
<style lang="scss">
.third-party-report{
    width: 840px;
    padding-top: 50px;
    padding-bottom: 80px;
    .module{
      margin-bottom: 20px;
      .module-title{
        font-size: 18px;
        color: #333;
        line-height: 30px;
        margin-bottom: 22px;
      }
      .pic-list{
        overflow: hidden;
        >li{
          float: left;
          margin-right: 20px;
          margin-bottom: 10px;
        }
        .pic{
          display: block;
          width: 80px;
          height: 80px;
          border: 1px solid #e5e5e5;
        }
      }
      .desc{
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
}
</style>